module.exports = "/lucky-balls/img/bigball/BigBall_020.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_020.png
// module id = 915
// module chunks = 0